export default "__VITE_ASSET__Nt9LmB4z__"